// Картинка с другого домена (бакет ассетов deadlock-api отдаёт CORS): её пиксели можно
// читать на canvas — для перекраски иконок и миникарты.
export const loadImage = async (url: string): Promise<HTMLImageElement> => {
  const image = new Image();
  image.crossOrigin = "anonymous";
  image.src = url;
  await image.decode();
  return image;
};
